import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { BaseResponse, ListResponse, ArrayResponse } from '../_common';
import { environment } from '../../environments/environment';
import { Advertiser } from '../_models';

@Injectable({ providedIn: 'root' })
export class AdvertiserService {

    constructor(private http: HttpClient) { }

    getAdvertiser(id: any): Observable<Advertiser> { //detail
      return this.http.get(`${environment.apiUrl}/offer-stream/advertiser/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new Advertiser().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/offer-stream/advertiser/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, Advertiser);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addAdvertiser(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/offer-stream/advertiser/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateAdvertiser(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/offer-stream/advertiser/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteAdvertiser(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/offer-stream/advertiser/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAllAdvertiserForSelection(): Observable<ArrayResponse> {
      return this.http.get(`${environment.apiUrl}/offer-stream/advertiser/list-all`)
      .pipe(
        map((data: any) => {
          if(data.status == 1 && data.data == undefined){
            return null;
          }else{
            return new ArrayResponse().deserialize(data, Advertiser);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

}
